<script setup lang="ts">
import DsIcon from './DsIcon.vue'
</script>

<template>
  <nav class="bottom-nav show-mobile" aria-label="手机底部导航">
    <RouterLink to="/"><DsIcon name="home" :size="22" /><span>首页</span></RouterLink>
    <RouterLink to="/find"><DsIcon name="search" :size="22" /><span>找球</span></RouterLink>
    <RouterLink class="bottom-create" to="/activities/new"><DsIcon name="add" :size="29" /><span>发布</span></RouterLink>
    <RouterLink to="/me"><DsIcon name="person" :size="22" /><span>我的</span></RouterLink>
  </nav>
</template>
